import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactNode, useState } from 'react';

import { TooltipProvider } from '@/components/ui/tooltip';
import { Toaster } from '@/components/ui/sonner';
import { AnalyticsProvider } from '../lib/analytics/tracker';
import { AuthProvider } from '../lib/auth/provider';

type AppProvidersProps = {
  children: ReactNode;
};

export function AppProviders({ children }: AppProvidersProps) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={300}>
        <AnalyticsProvider>
          <AuthProvider>{children}</AuthProvider>
        </AnalyticsProvider>
        <Toaster />
      </TooltipProvider>
    </QueryClientProvider>
  );
}
